import React, { useContext } from "react";
import { SessionDetail } from "../common/interfaces";

export const sessionDetailContext = (sessionDetail: SessionDetail) => {
	return {
		sessionDetail,
	};
};

type SessionDetailContextType = ReturnType<typeof sessionDetailContext>;

export const SessionContext = React.createContext<SessionDetailContextType>(
	sessionDetailContext({ accessToken: "", userInfo: undefined })
);

export const useSessionDetailContext = (): SessionDetailContextType => {
	return useContext(SessionContext);
};
